const questions = [
    {
      id: 1,
      title: 'What do I need to register as an SPO?',
      info:
        "A light wallet, e.g. Nami, Eternl, and the main wallet you receive pool's rewards to. The latter does not have to be a web extension wallet.",
    },
    {
      id: 2,
      title: 'What do I need to register as an NFT project owner?',
      info:
        "A light wallet, e.g. Nami, Eternl, and the main wallet you receive collection's royalties to. The latter does not have to be a web extension wallet.",
    },
    {
      id: 3,
      title: 'What do I need to register as a whale?',
      info:
        "A light wallet, e.g. Nami, Eternl, and a main wallet that has more than 1M ADA. The latter does not have to be a web extension wallet.",
    },
    {
      id: 4,
      title: 'Can my NFT project account have more than one collection?',
      info:
        "Yes, you can add additional policy IDs, however, a proof of ownership will be required for each added policy ID. This is done by proving ownership of the royalties wallet of given policy ID.",
    },
    {
      id: 5,
      title: 'Can my whale account have more than one whale wallet?',
      info:
        "Yes, you can add additional whale wallets, however, a proof of ownership will be required for each added wallet.",
    },
    {
      id: 6,
      title: 'Can SPOs have more than one affiliate partnership at a given time?',
      info:
        "Yes, there is no limit for the number of partnerships for SPOs.",
    },
    {
      id: 7,
      title: 'Can affiliates have more than one affiliate partnership at a given time?',
      info:
        "Each policy ID and whale wallet can have one partnership active at a given time. An NFT project with several collections (i.e. policy IDs) can have each policy affiliated with a different SPO. Similarly, a whale account can have each whale wallet affiliated with a different SPO.",
    },
    {
      id: 8,
      title: 'How do SPOs and their affiliates share rewards?',
      info:
        "The affiliate partnership reward distribution we are initially proposing is a proportional split of the pool's margin based on the percentage of the delegation an affiliate brings to your pool. Fixed fees are not shared. For example, this means if an affiliate provides 25% of the total delegation they will share 25% of the pool's margin rewards as commission, excluding fixed fees.",
    },
    {
      id: 9,
      title: 'Are there registration fees for SPOs or affiliates?',
      info:
        "No, the project is currently proposing in Catalyst F10 to cover expenses of team members to build the platform.",
    },
    {
      id: 10,
      title: 'Are there any recurring payments for using the platform?',
      info:
        "There are no direct fees charged to SPOs or their affiliates. However, for the transactions made to distribute rewards, the platform will have a service fee of 2 ADA. Any additional tips given by SPOs to any affiliates will not incur any charge. Thus, a service fee of 2 ADA per epoch from rewards if the stake pool mints a block or more.",
    },
  ]
  export default questions